export default {
    "entityName": "siterequest",
    upsert: 'full',
    // "title": "Site request",
    "pagination": {
        "itemsPerPage": 5,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            value: 'status',
            text: 'Status',
            table: true
        },
        {
            value: 'drugs',
            text: 'Drugs',
            table: {
                sortable: false
            },
            render: item => item.status === 'SENT' ?
                item.response_drugs && item.response_drugs.reduce((drugs, drug) => drugs += `${drug.name}${drug.dose} `, '') :
                item.request_drugs && item.request_drugs.reduce((drugs, drug) => drugs += `${drug.name}${drug.dose} ` , ''),
            visible: false
        }

    ],
    "actions": [
        { "value": "view", "text": "View", "color": "primary", "icon": "mdi-forward" }
    ]
}